export enum ProjectStatus {
  active = 0,
  deleted = 1,
}
